export class Camp {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.announcement = form.announcement; // 注意事项
      this.converImage = form.converImage;
      this.time = [form.beginTime, form.endTime];
      this.coachId = form.coachId;
      this.coachSelectVO = form.coachSelectVO;
      this.content = form.content; // 介绍
      this.suggestedNumberOfPeople = form.suggestedNumberOfPeople; // 建议人数
      this.movingTarget = form.movingSelectVO.map(item => item.id);
      this.name = form.name;
      this.recommendEquipments = form.equipmentSelectVO || [];
      this.taskList = [];
      this.differDay =
        form.differDay !== null ? form.differDay : 3; // 报名截止时间
    } else {
      this.clear();
    }
  }

  get time() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set time(time) {
    if (time && Array.isArray(time) && time.length === 2) {
      this.beginTime = time[0];
      this.endTime = time[1];
    } else {
      this.beginTime = "";
      this.endTime = "";
    }
  }

  clear() {
    this.id = "";
    this.announcement = "";
    this.converImage = {};
    this.time = [];
    this.coachId = [];
    this.coachSelectVO = [];
    this.content = "";
    this.suggestedNumberOfPeople = ""; // 建议人数
    this.movingTarget = [];
    this.name = "";
    this.recommendEquipments = [];
    this.differDay = 3;
    this.taskList = [];
  }
}
